import { matchesMediaQuery ,imageLoaded, videoLoaded, __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";
import { animate as animate21, inView as inView15, Delegate } from "vendor";
var _delegate, _onReveal, onReveal_fn, _muteVideo, muteVideo_fn, _unmuteVideo, unmuteVideo_fn, _onVolumeChange, onVolumeChange_fn;
var MediaGridGHD = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _onReveal);
    __privateAdd(this, _muteVideo);
    __privateAdd(this, _unmuteVideo);
	__privateAdd(this, _onVolumeChange);
    __privateAdd(this, _delegate, new Delegate(this));
	
    __privateGet(this, _delegate).on("click", '[data-action="unmute"]', __privateMethod(this, _unmuteVideo, unmuteVideo_fn).bind(this));
    __privateGet(this, _delegate).on("click", '[data-action="mute"]', __privateMethod(this, _muteVideo, muteVideo_fn).bind(this));
	
    this.addEventListener("volumechange", __privateMethod(this, _onVolumeChange, onVolumeChange_fn), { capture: true });
  }
  connectedCallback() {
    if (matchesMediaQuery("motion-safe")) {
      inView15(this.querySelectorAll('[reveal-on-scroll="true"]'), __privateMethod(this, _onReveal, onReveal_fn).bind(this), { margin: "-200px 0px 0px 0px" });
    }
  }
  
  disconnectedCallback() {
    __privateGet(this, _delegate).destroy();
  }
};

_delegate = new WeakMap();

_onReveal = new WeakSet();
onReveal_fn = async function(entry) {
  await imageLoaded(entry.target.querySelector(":scope > img"));
  animate21(entry.target, { opacity: [0, 1] }, { duration: 0.35, easing: "ease" });
};

_muteVideo = new WeakSet();
muteVideo_fn = function(event) {
  event.preventDefault();
  Array.from(event.target.closest('.media-grid__item').querySelectorAll("video")).filter((video) => video.offsetParent).forEach((video) => video.muted = true);
};

_unmuteVideo = new WeakSet();
unmuteVideo_fn = function(event) {
  event.preventDefault();
  Array.from(event.target.closest('.media-grid__item').querySelectorAll("video")).filter((video) => video.offsetParent).forEach((video) => video.muted = false);
};

_onVolumeChange = new WeakSet();
onVolumeChange_fn = function(event) {
  const volumeControl = event.target.closest(".media-grid__item").querySelector(".content-card__volume-control");
  if (volumeControl) {
    volumeControl.querySelector('[data-action="unmute"]').hidden = !event.target.muted;
    volumeControl.querySelector('[data-action="mute"]').hidden = event.target.muted;
  }
};



if (!window.customElements.get("media-grid-ghd")) {
  window.customElements.define("media-grid-ghd", MediaGridGHD);
}

export {
	MediaGridGHD
};
